import React from 'react';

import { SvgIcon } from '@mui/material';

import AppIconPillButton, {
  IAppIconPillButtonProps,
} from '../app-icon-pill-button/AppIconPillButton';

export function AppAddPillButton({
  colorVariant = 'primary',
  ...props
}: IAppIconPillButtonProps) {
  return (
    <AppIconPillButton colorVariant={colorVariant} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round">
        <path d="M5 12h14"></path>
        <path d="M12 5v14"></path>
      </svg>
    </AppIconPillButton>
  );
}

export default AppAddPillButton;
